import uiPaymentTable from './payment-table/index.vue'

export { uiPaymentTable }
